import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';

function LogoutDialogComponent({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" style={{ fontFamily: 'Futura' }}>
        {"Are you sure you want to Log-out?"}
      </DialogTitle>
      <DialogActions>
        <Button variant="contained" color='success' onClick={onClose}>Cancel</Button>
        <Button variant="contained" color='error' onClick={onConfirm} autoFocus>Confirm</Button>
      </DialogActions>
    </Dialog>
  );
}

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [openDialogue, setOpenDialogue] = useState(false);

  const handledialogueOpen = () => setOpenDialogue(true);
  const handledialogueClose = () => setOpenDialogue(false);

  const logout_now = () => {
    logout();
    setOpenDialogue(false);
    navigate('/');
  };

  const LogoutDialog = (
    <LogoutDialogComponent
      open={openDialogue}
      onClose={handledialogueClose}
      onConfirm={logout_now}
    />
  );

  return {
    handledialogueOpen,
    LogoutDialog,
  };
};

export default useLogout;
